<!-- HEAD -->
<app-main-head [breadcrumbItems]="breadcrumbItems" [isSearchRequired]="false" [mainTitle]="'NAVBAR_TAB.LEGAL_NOTES'"
    [isRightPanelVisible]="false">
</app-main-head>
<!-- END HEAD -->
<!-- NEED BODY -->